module.exports = __webpack_public_path__ + "static/img/setting.d5b6e148.png";